import React from 'react'
import {useIntl} from 'react-intl'
import {toAbsoluteUrl} from '../../../../_gori/helpers'
import {convertCurrency} from '../../../../_gori/helpers/ConvertHelpers'

const SAMPLE_RATES = [
  {
    carrier: 'USPS',
    service: 'USPS Priority',
    from: 'Anaheim, CA',
    to: 'Albuquerque, NM',
    originalPrice: '25.40',
    discountedPrice: '19.82',
    discount: '22%',
  },
  {
    carrier: 'USPS',
    service: 'USPS Ground Advantage',
    from: 'Auburn, PA',
    to: 'Duckwater, NV',
    originalPrice: '34.20',
    discountedPrice: '20.51',
    discount: '40%',
  },
  {
    carrier: 'UPS',
    service: 'UPS Ground',
    from: 'Moundville, AL',
    to: 'Spokane, WA',
    originalPrice: '51.41',
    discountedPrice: '14.03',
    discount: '72%',
  },
  {
    carrier: 'FedEx',
    service: 'FedEx Home Delivery',
    from: 'Wichita, KS',
    to: 'Sutton, NE',
    originalPrice: '21.53',
    discountedPrice: '17.15',
    discount: '20%',
  },
]

const SampleRateCard: React.FC<{
  carrier: string
  service: string
  from: string
  to: string
  originalPrice: string
  discountedPrice: string
  discount: string
}> = ({carrier, service, from, to, originalPrice, discountedPrice, discount}) => {
  const intl = useIntl()

  return (
    <div className='shipping-calc__sample-card bg-white d-flex flex-row align-items-center align-self-stretch justify-content-between'>
      <div className='shipping-calc__sample-info d-flex align-items-center'>
        <img
          src={toAbsoluteUrl(`/media/gori/carrier-logos/${carrier.toLowerCase()}.png`)}
          alt={carrier}
          className='shipping-calc__carrier-icon rounded-1 flex-shrink-0'
        />
        <div className='shipping-calc__sample-details d-flex flex-column align-items-start'>
          <div className='shipping-calc__service-name color-blue-dark lh-normal fw-bolder fs-4'>
            {service}
          </div>
          <div className='shipping-calc__service-address fw-semibold'>
            {intl.formatMessage({id: 'FROM_COLON'})} {from}
          </div>
          <div className='shipping-calc__service-address fw-semibold'>
            {intl.formatMessage({id: 'TO_COLON'})} {to}
          </div>
        </div>
      </div>
      <div className='d-flex flex-column align-items-end'>
        <div className='shipping-calc__original-price lh-normal fw-bolder fs-4'>
          {convertCurrency(originalPrice)}
        </div>
        <div className='shipping-calc__discounted-price lh-normal'>
          {convertCurrency(discountedPrice)}
        </div>
      </div>
      <div className='shipping-calc__discount-badge py-1 px-3 d-flex justify-content-center align-items-center'>
        <span className='text-white text-center fs-4 fw-bold lh-base'>{discount}</span>
      </div>
    </div>
  )
}

export const SampleRates: React.FC = () => {
  const intl = useIntl()

  return (
    <div className='shipping-calc__samples shipping-calc__w100-480 d-flex flex-column align-items-start gap-5'>
      <div className='fs-2 color-blue-dark fw-bolder lh-base'>
        {intl.formatMessage({id: 'REDUCED_SHIPPING_COSTS'})}
      </div>
      {SAMPLE_RATES.map((rate) => (
        <SampleRateCard key={`${rate.carrier}_${rate.service}`} {...rate} />
      ))}
    </div>
  )
}
